import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';
import { Observable } from 'rxjs';
import { SocialChannel } from '../../models';
import { IconComponent } from '@teamfoster/sdk/icon';
import { SocialIconPipe } from '../../pipes/social-icon.pipe';

@Component({
  selector: 'app-social-channel-buttons',
  templateUrl: './social-channel-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styleUrls: ['./social-channel-buttons.component.scss'],
  imports: [IconComponent, SocialIconPipe],
})
export class SocialChannelButtonsComponent {
  title = input<string>();
  channels = input.required<SocialChannel[]>();
}
